import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { postSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, refreshSettings } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;
    if (!session_id) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const data = await postSession(session_id);
        setUser(data.user);
        await refreshSettings();
        // clear hash
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (_e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser, refreshSettings]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50">
      <div className="text-center">
        <div className="inline-block h-8 w-8 border-2 border-orange-500 border-t-transparent rounded-full animate-spin mb-3"></div>
        <p className="text-sm text-zinc-600 font-mono">Authenticating…</p>
      </div>
    </div>
  );
}
